import { useCallback, useContext, useEffect, useRef } from 'react';

import { FacebookPixelContext, TiktokPixelContext } from 'context/tracking/declarations';
import { trackAddToCart } from 'context/tracking/addToCart';
import { EventTrackingDetail } from 'shared/interfaces/marketing/event-tracking-detail.interface';

export const useSeatsMapAddToCart = () => {
	const { state: facebookPixel } = useContext(FacebookPixelContext);
	const { state: tiktokPixel } = useContext(TiktokPixelContext);
	const pixelsRef = useRef({ facebookPixel, tiktokPixel });

	useEffect(() => {
		pixelsRef.current = { facebookPixel, tiktokPixel };
	}, [facebookPixel, tiktokPixel]);

	return useCallback((ev: Event) => {
		const { facebookPixel: facebook, tiktokPixel: tiktok } = pixelsRef.current;
		trackAddToCart((ev as CustomEvent<EventTrackingDetail>).detail, facebook, tiktok);
	}, []);
};
